export enum SettingsTabKey {
  ACCOUNT_AND_SUBSCRIPTION = 'accountAndSubscription',
  INVOICES = 'invoices',
  DEVICES = 'devices',
  PROFILES = 'profiles',
}
